import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { StaticTable } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { useDraftRows } from '~/pages/DraftsDashboard/hooks/useDraftRows';
import { createdDraftsColumns, createdDraftsMainColumn, draftTitleOf, draftTitlesById } from './CreatedDraftsTable.utils';
const NO_SUMMARY_ROWS = [];
export const CreatedDraftsTable = (param)=>{
    let { drafts, testId } = param;
    const { t: draftsTexts } = useLocaleKeys('proposal.draftsDashboard');
    const rows = useDraftRows(drafts);
    const titleById = useMemo(()=>draftTitlesById(drafts), [
        drafts
    ]);
    const mainColumn = useMemo(()=>createdDraftsMainColumn(draftsTexts.companyName(), draftTitleOf(titleById)), [
        titleById
    ]);
    const columns = useMemo(()=>createdDraftsColumns(draftsTexts.modifiedBy(), draftsTexts.lastModified()), []);
    const mobile = useMemo(()=>({
            fields: [
                {
                    name: 'modifiedBy',
                    label: draftsTexts.modifiedBy()
                },
                {
                    name: 'lastModified',
                    label: draftsTexts.lastModified()
                }
            ]
        }), []);
    return /*#__PURE__*/ _jsx(StaticTable, {
        testId: testId,
        mainColumn: mainColumn,
        columns: columns,
        items: rows,
        getRowId: (row)=>row.id,
        mobile: mobile,
        summaryRows: NO_SUMMARY_ROWS
    });
};
